// External imports
import React from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { FiCopy, FiCheck } from "react-icons/fi"

import { withMicrocopy } from "~contexts/MicrocopyContext"

const CopyButton = ({
  enabled, text, onCopy, copied, microcopy,
}) => (
  <>
    {enabled && (
      <CopyToClipboard text={text} onCopy={onCopy}>
        <button data-role="button">
          {copied ? <FiCheck /> : <FiCopy />}
          <span>{microcopy.text("reference.buttons.copy")}</span>
        </button>
      </CopyToClipboard>
    )}
  </>
)

export default withMicrocopy(CopyButton)
